<template>
    <a v-if="url" :target="target" :href='url'>
      <img :src="imageSource" class="img-fluid" :alt="alternateText" :style="styles" :class="classes" />
    </a>
    <img v-else :src="imageSource" class="img-fluid" :alt="alternateText" :style="styles" :class="classes" />

</template>

<script>
export default {
  name: "square-image",
  props: {
    target:String,
    imageSource: {
      type: String,
      default: "@/assets/logo.png"
    },
    alternateText: {
      type: String,
      default: "Sample Image"
    },
    url:{
      type:String
    },
    styles:{
      type: Object,
      default:()=>{}
    },
    classes: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped lang="scss">
img[data-field-type="square-image"] {
  object-fit: cover
}
.img-fluid {
  @media (max-width: 712px) {
    margin: 0 !important;
  }
}
.top-image {
  width: 100%;
  height: 100%;
  @media (max-width: 1024px) {
    border-radius: 30px;
  }
}
</style>